// stati e date degli articoli del blog, comuni a lista, dettaglio e scheda
import moment from 'moment';

export const STATI = {
	BOZZA: { label: 'Bozza', colore: 'grey', icona: 'mdi-pencil-outline' },
	CREATO: { label: 'Creato', colore: 'info', icona: 'mdi-robot-outline' },
	PUBBLICATO: { label: 'Pubblicato', colore: 'success', icona: 'mdi-earth' },
	ANNULLATO: { label: 'Annullato', colore: 'error', icona: 'mdi-cancel' },
};

export function stato(s) {
	return STATI[s] || { label: s || '—', colore: 'grey', icona: 'mdi-help-circle-outline' };
}

// "tra 3 giorni", "oggi", "3 giorni fa"
export function quando(d) {
	if (!d) return '';
	const giorni = moment(d).startOf('day').diff(moment().startOf('day'), 'days');
	if (giorni === 0) return 'oggi';
	if (giorni === 1) return 'domani';
	if (giorni === -1) return 'ieri';
	return giorni > 0 ? `tra ${giorni} giorni` : `${-giorni} giorni fa`;
}

export function titolo(item) {
	return (item && item.name && item.name.name) || 'Articolo senza titolo';
}
